export const maxCostAmount = 100000;
export const maxCharDescription = 255;